export const ADD_PRODUCT_BASKET = 'ADD_PRODUCT_BASKET';
export const GET_NUMBERS_BASKET = 'GET_NUMBERS_BASKET';
export const INCREASE_QUANTITY = 'INCREASE_QUANTITY';
export const DECREASE_QUANTITY = 'DECREASE_QUANTITY';
export const CLEAR_PRODUCT = 'CLEAR_PRODUCT';